import styled from 'styled-components'
import IconArrowRight from '../../../vectors/IconArrowRight'

const ArrowRight = styled(IconArrowRight)`
  width: 10px;
  margin-right: 5px;
  path {
    fill: ${(props) => props.theme.colors.blue};
  }
`

export { ArrowRight }
